// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/components/MetricsViewer.css */

.metrics-viewer {
  font-family: 'Courier New', monospace;
}

.metrics-viewer .table {
  font-size: 0.9rem;
}

.metrics-viewer .table th {
  background-color: #f8f9fa;
  font-weight: 600;
  border-top: none;
}

.metrics-viewer .table td {
  vertical-align: middle;
}

.metrics-viewer code {
  background-color: #f1f3f4;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 0.85em;
  color: #d63384;
}

.metrics-viewer .badge {
  font-size: 0.7em;
}

.metrics-viewer .table-responsive {
  border-radius: 0.375rem;
}

.metrics-viewer .search-highlight {
  background-color: #fff3cd;
  padding: 1px 2px;
  border-radius: 2px;
}

.metrics-viewer .metric-value {
  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
  font-weight: 600;
}

.metrics-viewer .metric-help {
  font-size: 0.8rem;
  line-height: 1.3;
  max-width: 200px;
}

.metrics-viewer .loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.metrics-viewer .no-data {
  text-align: center;
  padding: 2rem;
  color: #6c757d;
}

.metrics-viewer .stats-row {
  background-color: #f8f9fa;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.metrics-viewer .type-badge {
  font-size: 0.7rem;
  min-width: 60px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/MetricsViewer.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* frontend/src/components/MetricsViewer.css */\n\n.metrics-viewer {\n  font-family: 'Courier New', monospace;\n}\n\n.metrics-viewer .table {\n  font-size: 0.9rem;\n}\n\n.metrics-viewer .table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  border-top: none;\n}\n\n.metrics-viewer .table td {\n  vertical-align: middle;\n}\n\n.metrics-viewer code {\n  background-color: #f1f3f4;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-size: 0.85em;\n  color: #d63384;\n}\n\n.metrics-viewer .badge {\n  font-size: 0.7em;\n}\n\n.metrics-viewer .table-responsive {\n  border-radius: 0.375rem;\n}\n\n.metrics-viewer .search-highlight {\n  background-color: #fff3cd;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.metrics-viewer .metric-value {\n  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;\n  font-weight: 600;\n}\n\n.metrics-viewer .metric-help {\n  font-size: 0.8rem;\n  line-height: 1.3;\n  max-width: 200px;\n}\n\n.metrics-viewer .loading-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n}\n\n.metrics-viewer .no-data {\n  text-align: center;\n  padding: 2rem;\n  color: #6c757d;\n}\n\n.metrics-viewer .stats-row {\n  background-color: #f8f9fa;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  margin-bottom: 1rem;\n}\n\n.metrics-viewer .type-badge {\n  font-size: 0.7rem;\n  min-width: 60px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
